import FallbackBackground from "../components/FallbackBackground";
import Footer from "../components/Footer";
import Header from "../components/Header";
import MarkdownHtml from "../components/MarkdownHtml";

type LegalMarkdownProps = {
  htmlText: string;
};

export default function LegalMarkdown({ htmlText }: LegalMarkdownProps) {
  return (
    <div
      className="bg-background text-foreground dark relative min-h-screen overflow-x-clip"
      style={{ scrollBehavior: "smooth" }}
    >
      <FallbackBackground variant="dark-flat" />

      {/* Skip to content link for accessibility */}
      <a
        href="#main-content"
        className="focus:bg-primary focus:text-primary-foreground sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:rounded-md focus:px-4 focus:py-2 focus:shadow-lg"
      >
        Skip to main content
      </a>

      {/* Content wrapper with relative positioning */}
      <div className="relative z-10 pt-20">
        <Header />

        {/* Main Content */}
        <main id="main-content">
          <MarkdownHtml htmlText={htmlText} />
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </div>
  );
}
